import React from 'react';

import Icon, { Props } from './icon';

export const RecordIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40">
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse cx="20.5" cy="20" rx="15" ry="15" stroke="#F2F2F2" strokeWidth="2.7" />
        <ellipse cx="20.5001" cy="20" rx="8.33333" ry="8.33333" fill="#F2F2F2" />
      </svg>
      ;
    </Icon>
  );
};

export default React.memo(RecordIcon);
